var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Icons/Service/Close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.4183 12.4182,16 8,16 C3.58179,16 0,12.4183 0,8 C0,3.58179 3.58179,0 8,0 C12.4182,0 16,3.58179 16,8 Z M10.55,11.6501 C10.8499,11.9501 11.3501,11.9501 11.6499,11.6501 C11.95,11.3501 11.95,10.8501 11.6499,10.55 L9.1001,8.00012 L11.6499,5.45007 C11.95,5.15015 11.95,4.65015 11.6499,4.3501 C11.3501,4.05017 10.8499,4.05017 10.55,4.3501 L8,6.90015 L5.44995,4.3501 C5.1499,4.05017 4.6499,4.05017 4.3501,4.3501 C4.05005,4.65015 4.05005,5.15015 4.3501,5.45007 L6.8999,8.00012 L4.3501,10.55 C4.05005,10.8501 4.05005,11.3501 4.3501,11.6501 C4.6499,11.9501 5.1499,11.9501 5.44995,11.6501 L8,9.1001 L10.55,11.6501 Z",
    id: "Shape",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.9d3861a5849505c694fc61ace236c61e.svg";
export { ForwardRef as ReactComponent };